import ApiMethods from "./config";

export default class ApiManager {
  static getUser = async (expand) => {
    return await ApiMethods.get("/user", {
      expand,
    });
  };

  static getUserEmailToken = async (type, email) => {
    return await ApiMethods.get("/user/email-token", {
      type,
      email,
    });
  };

  static postUser = async (tokenType, token, email, passwordPlain) => {
    return await ApiMethods.post("/user", {
      token_type: tokenType,
      token,
      email,
      password_plain: passwordPlain,
    });
  };

  static postUserLogin = async (tokenType, token, email, passwordPlain) => {
    return await ApiMethods.post("/user/login", {
      token_type: tokenType,
      token,
      email,
      password_plain: passwordPlain,
    });
  };

  static postUserLogout = async () => {
    return await ApiMethods.post("/user/logout");
  };

  static postUserPasswordReset = async (token, email, newPasswordPlain) => {
    return await ApiMethods.post("/user/password-reset", {
      token,
      email,
      new_password_plain: newPasswordPlain,
    });
  };

  static postSubscriptionUpdate = async (rfc, newPlanName) => {
    return await ApiMethods.post("/user/rfc/update-subscription", {
      rfc,
      new_plan_name: newPlanName,
    });
  };

  static postUserRfcRefreshSchedule = async (rfc, refreshSchedule) => {
    return await ApiMethods.post("/user/rfc/refresh-schedule", {
      rfc,
      refresh_schedule: refreshSchedule,
    });
  };

  static postUserFeedback = async (
    starCount,
    feedbackText,
    rfc,
    satFiscalName,
  ) => {
    return await ApiMethods.post("/user/feedback", {
      star_count: starCount,
      feedback: feedbackText,
      rfc,
      sat_fiscal_name: satFiscalName,
    });
  };

  static postUserCreditCoupon = async (couponName) => {
    return await ApiMethods.post("/user/credit-coupon", {
      coupon: couponName,
    });
  };

  static getUserRfcEfosLinks = async (rfc, pagination_token) => {
    return await ApiMethods.get("/user/rfc-efos-links", {
      rfc,
      pagination_token,
    });
  };

  static getUserCfdisRfcLink = async (
    rfc_type,
    rfc_emitter,
    rfc_receiver,
    pagination_token,
  ) => {
    return await ApiMethods.get("/user/cfdis-rfc-link", {
      rfc_type,
      rfc_emitter,
      rfc_receiver,
      pagination_token,
    });
  };

  static getUserCfdis = async (
    id_cfdi,
    rfc_emitter,
    rfc_receiver,
    search_filters,
    pagination_token,
  ) => {
    return await ApiMethods.get("/user/cfdis", {
      id_cfdi,
      rfc_emitter,
      rfc_receiver,
      search_filters,
      pagination_token,
    });
  };

  static getUserCfdiLinks = async (id_cfdi, pagination_token) => {
    return await ApiMethods.get("/user/cfdi/links", {
      id_cfdi,
      pagination_token,
    });
  };

  static getUserRfcs = async (rfc, pagination_token) => {
    return await ApiMethods.get("/user/rfcs", {
      rfc,
      pagination_token,
    });
  };

  static getFileUploadLink = async (upload_type, rfc, file_type) => {
    return await ApiMethods.get("/file-upload-link", {
      upload_type,
      rfc,
      file_type,
    });
  };

  static postUserRfcSatActivate = async (rfc, pkey_passphrase_plain) => {
    return await ApiMethods.post("/user/rfc/sat-activate", {
      rfc,
      pkey_passphrase_plain,
    });
  };

  static postUserRfcSatManualUpdate = async (rfc) => {
    return await ApiMethods.post("/user/rfc/sat-manual-update", {
      rfc,
    });
  };

  static getUserRfcCsfPdf = async (rfc) => {
    return await ApiMethods.get("/user/rfc-csf-pdf", {
      rfc,
    });
  };

  static getUserStripeCheckoutSession = async (
    return_to,
    rfc,
    new_plan_name,
  ) => {
    return await ApiMethods.get("/user/stripe-checkout-session", {
      return_to,
      rfc,
      new_plan_name,
    });
  };

  static getUserSubscriptionUpdatesPreviewInvoice = async (
    old_plan_name,
    new_plan_name,
  ) => {
    return await ApiMethods.get("/user/subscription/updates-preview-invoice", {
      old_plan_name,
      new_plan_name,
    });
  };
}
